import type {
  AccessManagementAccountGetResponse,
  AccessManagementClinicUserGetResponse,
  ClinicAPIEntity,
} from '@surglogs-app/network'

const BLACKLISTED_EMAIL_REGEXES = [/mofa.sk$/] as const
const BLACKLISTED_RECORDING_EMAIL_REGEXES = [
  /surglogs.com$/,
  /mofa.sk$/,
] as const

export const isUserTrackable = ({
  user,
  clinic,
}: {
  user?:
    | AccessManagementClinicUserGetResponse
    | AccessManagementAccountGetResponse
    | null
  clinic?: ClinicAPIEntity | { id: number } | null
}) => {
  const capturingEnabled =
    !BLACKLISTED_EMAIL_REGEXES.some((blacklistedEmail) =>
      user?.email?.match(blacklistedEmail),
    ) && !!user
  const recordingEnabled =
    !BLACKLISTED_RECORDING_EMAIL_REGEXES.some((blacklistedEmail) =>
      user?.email?.match(blacklistedEmail),
    ) && !!user

  if (clinic && 'report' in clinic && !clinic.report) {
    return { capturingEnabled: false, recordingEnabled: false }
  }

  return { capturingEnabled, recordingEnabled }
}
